import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import clsx from 'clsx';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, error, hint, className, id, ...props },
  ref,
) {
  const inputId = id ?? props.name;
  return (
    <label className="flex flex-col gap-1.5" htmlFor={inputId}>
      {label ? <span className="text-meta text-content-secondary">{label}</span> : null}
      <input
        ref={ref}
        id={inputId}
        className={clsx(
          'h-10 rounded-control border bg-surface-secondary px-3 text-body text-content',
          'placeholder:text-content-muted transition-colors duration-fast',
          'hover:border-line-strong focus:border-accent focus:outline-none',
          error ? 'border-error' : 'border-line',
          className,
        )}
        {...props}
      />
      {error ? <span className="text-meta text-error">{error}</span> : null}
      {!error && hint ? <span className="text-meta text-content-muted">{hint}</span> : null}
    </label>
  );
});
